const EditButton: React.FC = () => {
  return (
    <div className='icon'>
      <img src={require('./editButt.png')} alt='edit' />
    </div>
  )
}

export default EditButton
